export default __webpack_public_path__ + "static/media/Stormy_01.952c33b9.png";